import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

import styles from './Tooltip.module.scss';

/**
 * Подсказка при наведении.
 *
 * Провайдер ставится один раз в оболочке приложения: у Radix он держит общую
 * задержку, чтобы соседние подсказки открывались сразу, пока курсор гуляет
 * по панели кнопок, а не ждали по полсекунды каждая.
 */
export const TooltipProvider = RadixTooltip.Provider;

export interface TooltipProps {
  /** Текст подсказки. Пустой — подсказка не рисуется вовсе. */
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Элемент, к которому крепится подсказка. Должен принимать ref. */
  children: ReactNode;
}

export function Tooltip({ content, side = 'top', children }: TooltipProps) {
  if (content === undefined || content === null || content === '') {
    return children;
  }

  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content className={styles['tooltip']} side={side} sideOffset={6}>
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
